export default __webpack_public_path__ + "static/media/exclamation_icon.9bea1c8c.svg";